import { AutoSaveComponent } from "@gx1/gx-ui-common";
import { useEffect, useState } from "react";
import { CustomEvents } from "../../../app.constants";
import styles from "./save-indicator.styles.module.scss";

const SaveIndicatorComponent = () => {
  const [overviewEditCount, setOverviewEditCount] = useState(0);
  const [selectionEditCount, setSelectionEditCount] = useState(0);
  const [requirementsEditCount, setRequirementsEditCount] = useState(0);
  const [checklistEditCount, setChecklistEditCount] = useState(0);
  const [detailsEditCount, setDetailsEditCount] = useState(0);

  useEffect(() => {
    const overviewListener = (event: CustomEvent) => setOverviewEditCount(event.detail.count || 0);
    const requirementsListener = (event: CustomEvent) => setRequirementsEditCount(event.detail.count || 0);
    const selectionListener = (event: CustomEvent) => setSelectionEditCount(event.detail.count || 0);
    const checklistListener = (event: CustomEvent) => setChecklistEditCount(event.detail.count || 0);
    const detailsListener = (event: CustomEvent) => setDetailsEditCount(event.detail.count || 0);

    window.addEventListener(CustomEvents.OVERVIEW_EDIT_COUNT, overviewListener);
    window.addEventListener(CustomEvents.REQUIREMENTS_EDIT_COUNT, requirementsListener);
    window.addEventListener(CustomEvents.SELECTION_EDIT_COUNT, selectionListener);
    window.addEventListener(CustomEvents.CHECKLIST_EDIT_COUNT, checklistListener);
    window.addEventListener(CustomEvents.DETAILS_EDIT_COUNT, detailsListener);
    return () => {
      window.removeEventListener(CustomEvents.OVERVIEW_EDIT_COUNT, overviewListener);
      window.removeEventListener(CustomEvents.REQUIREMENTS_EDIT_COUNT, requirementsListener);
      window.removeEventListener(CustomEvents.SELECTION_EDIT_COUNT, selectionListener);
      window.removeEventListener(CustomEvents.CHECKLIST_EDIT_COUNT, checklistListener);
      window.removeEventListener(CustomEvents.DETAILS_EDIT_COUNT, detailsListener);
    };
  }, []);

  return (
    <div className={styles.saveIndicatorWrapper}>
      <AutoSaveComponent
        includeLabel={false}
        isSaving={overviewEditCount > 0 || selectionEditCount > 0 || requirementsEditCount > 0 || checklistEditCount > 0 || detailsEditCount > 0}
      />
    </div>
  );
};

export default SaveIndicatorComponent;
